import { render, staticRenderFns } from "./BorderBox5.vue?vue&type=template&id=b46333b8"
import script from "./BorderBox5.vue?vue&type=script&lang=js"
export * from "./BorderBox5.vue?vue&type=script&lang=js"
import style0 from "./BorderBox5.vue?vue&type=style&index=0&id=b46333b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports